import { useStateMachine } from 'little-state-machine';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';

import { Button, Expand, InputText } from '@/components';
import { updateFormActionLander } from '@/hooks';
import { OutletContext } from '@/model';
import { UsernameValidation } from '@/validations';

interface UsernameForm {
	username: string;
}

export const Username = () => {
	const { t } = useTranslation();
	const { handleNext, versionId }: OutletContext = useOutletContext();
	const {
		register,
		formState: { errors },
		handleSubmit,
	} = useForm<UsernameForm>({ resolver: UsernameValidation(t) });
	const { actions, state } = useStateMachine({ updateFormActionLander });

	const onSubmit = (data: UsernameForm) => {
		actions.updateFormActionLander({ lander: { ...state.lander, ...data } });
		handleNext();
	};

	return (
		<form onSubmit={handleSubmit(onSubmit)} className="flex flex-col">
			<div className="w-full">
				<InputText
					{...register('username')}
					placeholder={t('username.placeholder')}
				/>
				<Expand expanded={Boolean(errors.username)}>
					<p
						className={`pandora__form--error pandora__form--error--v${versionId}`}
					>
						{errors.username?.message}
					</p>
				</Expand>
			</div>
			<Button>{t('general.next')}</Button>
		</form>
	);
};
